import { render, staticRenderFns } from "./DesconsiderarConsumos.vue?vue&type=template&id=25042553"
import script from "./DesconsiderarConsumos.vue?vue&type=script&setup=true&lang=js"
export * from "./DesconsiderarConsumos.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports